<template>
  <div>{{ value }}</div>
</template> 
<script>
export default {
  methods: {},
  props: ["value"],
  mounted() {},
  watch: {},
};
</script>

<style lang="scss" scoped>
div {
  padding: 24px 16px;
}
</style>